"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectFieldStyles = void 0;

var _core = require("@material-ui/core");

var _formik = require("formik");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _async = _interopRequireDefault(require("react-select/async"));

var _FormikSingleSelectFieldModule = _interopRequireDefault(require("./FormikSingleSelectField.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SelectFieldStyles = {
  base: function base(provided) {
    return _objectSpread({}, provided, {
      zIndex: 9999
    });
  },
  menu: function menu(provided) {
    return _objectSpread({}, provided, {
      font: "400 16px 'Source Sans Pro'",
      borderRadius: '8px',
      padding: '4px',
      border: '1px solid #6e7370'
    });
  },
  control: function control(provided, _ref) {
    var isFocused = _ref.isFocused;
    return _objectSpread({}, provided, {
      boxShadow: '0px 0px 8px #F7F7F7',
      border: '1px solid #6e7370',
      padding: '5px 4px',
      background: 'white',
      font: "400 16px 'Source Sans Pro'",
      color: '#485146',
      fontSize: '16px',
      lineHeight: '140%',
      borderRadius: '4px',
      width: '100%',
      position: 'relative',
      boxSizing: 'border-box',
      cursor: 'text',
      outline: isFocused ? '5px auto #00c65f' : 'none',
      ':hover': {
        border: '1px solid #6e7370'
      }
    });
  },
  clearIndicator: function clearIndicator(provided) {
    return _objectSpread({}, provided, {
      color: '#6e7370',
      cursor: 'pointer'
    });
  },
  dropdownIndicator: function dropdownIndicator(provided) {
    return _objectSpread({}, provided, {
      color: '#6e7370',
      cursor: 'pointer'
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread({}, provided, {
      font: "400 16px 'Source Sans Pro'",
      color: '#bbbbbb'
    });
  },
  option: function option(provided, _ref2) {
    var isFocused = _ref2.isFocused,
        isSelected = _ref2.isSelected;
    return _objectSpread({}, provided, {
      borderRadius: '4px',
      // eslint-disable-next-line no-nested-ternary
      backgroundColor: isSelected ? '#EDFFF6' : isFocused ? '#F7F7F7' : 'white',
      // eslint-disable-next-line no-nested-ternary
      color: isSelected ? '#006B33' : isFocused ? '#00C65F' : '#485146',
      cursor: 'pointer',
      ':active': _objectSpread({}, provided[':active'], {
        backgroundColor: '#EDFFF6'
      })
    });
  },
  multiValue: function multiValue(provided) {
    return _objectSpread({}, provided, {
      backgroundColor: '#edfff6',
      border: '1px solid #009447',
      borderRadius: '4px',
      color: '#009447'
    });
  },
  multiValueLabel: function multiValueLabel(provided) {
    return _objectSpread({}, provided, {
      font: "400 16px 'Source Sans Pro'",
      color: '#009447'
    });
  },
  multiValueRemove: function multiValueRemove(provided) {
    return _objectSpread({}, provided, {
      color: '#009447',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#009447',
        color: 'white'
      }
    });
  }
};
exports.SelectFieldStyles = SelectFieldStyles;

var defaultLoadingFunc = function defaultLoadingFunc() {
  return 'Loading...';
};

var handleDefaultOnChange = function handleDefaultOnChange(selectedValue, selectedValueField, setTouched, touched, fieldName, setFieldValue) {
  setTouched(_objectSpread({}, touched, _defineProperty({}, fieldName, true)));
  setFieldValue(fieldName, selectedValueField ? selectedValue[selectedValueField] : selectedValue.id);
};

var FormikSingleSelectField = function FormikSingleSelectField(_ref3) {
  var value = _ref3.value,
      isLoading = _ref3.isLoading,
      loadingMessageFunc = _ref3.loadingMessageFunc,
      options = _ref3.options,
      placeholder = _ref3.placeholder,
      className = _ref3.className,
      fieldName = _ref3.fieldName,
      setTouched = _ref3.setTouched,
      setFieldValue = _ref3.setFieldValue,
      customOnChange = _ref3.customOnChange,
      label = _ref3.label,
      touched = _ref3.touched,
      errors = _ref3.errors,
      hideErrors = _ref3.hideErrors,
      isDisabled = _ref3.isDisabled,
      selectedValueField = _ref3.selectedValueField,
      isAsync = _ref3.isAsync,
      cacheOptions = _ref3.cacheOptions,
      loadOptions = _ref3.loadOptions,
      defaultOptions = _ref3.defaultOptions,
      props = _objectWithoutProperties(_ref3, ["value", "isLoading", "loadingMessageFunc", "options", "placeholder", "className", "fieldName", "setTouched", "setFieldValue", "customOnChange", "label", "touched", "errors", "hideErrors", "isDisabled", "selectedValueField", "isAsync", "cacheOptions", "loadOptions", "defaultOptions"]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: isDisabled ? [_FormikSingleSelectFieldModule.default.FormikSingleSelectField, _FormikSingleSelectFieldModule.default.disabled].join(' ') : _FormikSingleSelectFieldModule.default.FormikSingleSelectField
  }, label ? /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
    className: touched && errors && touched[fieldName] && errors[fieldName] ? [_FormikSingleSelectFieldModule.default.InputLabel, _FormikSingleSelectFieldModule.default.error].join(' ') : _FormikSingleSelectFieldModule.default.InputLabel
  }, label) : null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isAsync ? /*#__PURE__*/_react.default.createElement(_async.default, _extends({
    cacheOptions: cacheOptions,
    defaultOptions: defaultOptions,
    loadOptions: loadOptions,
    placeholder: placeholder || 'Select one',
    className: [className, _FormikSingleSelectFieldModule.default.Input].join(' '),
    styles: SelectFieldStyles,
    onChange: customOnChange ? function (selectedValue) {
      return customOnChange(selectedValue);
    } : function (selectedValue) {
      return handleDefaultOnChange(selectedValue, selectedValueField, setTouched, touched, fieldName, setFieldValue);
    },
    isDisabled: isDisabled,
    value: value
  }, props)) : /*#__PURE__*/_react.default.createElement(_reactSelect.default, _extends({
    value: value,
    isLoading: isLoading,
    isDisabled: isDisabled,
    loadingMessage: loadingMessageFunc || defaultLoadingFunc,
    options: options,
    placeholder: placeholder || 'Select one',
    className: [className, _FormikSingleSelectFieldModule.default.Input].join(' '),
    styles: SelectFieldStyles,
    onChange: customOnChange ? function (selectedValue) {
      return customOnChange(selectedValue);
    } : function (selectedValue) {
      return handleDefaultOnChange(selectedValue, selectedValueField, setTouched, touched, fieldName, setFieldValue);
    }
  }, props))), errors && !hideErrors ? /*#__PURE__*/_react.default.createElement("div", {
    className: _FormikSingleSelectFieldModule.default.ErrorMessageContainer
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: fieldName
  })) : null);
};

FormikSingleSelectField.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.array, _propTypes.default.number]),
  isAsync: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  loadingMessageFunc: _propTypes.default.func,
  options: _propTypes.default.array,
  cacheOptions: _propTypes.default.bool,
  loadOptions: _propTypes.default.func,
  defaultOptions: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.object]),
  placeholder: _propTypes.default.string,
  className: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node, _propTypes.default.func]),
  fieldName: _propTypes.default.string.isRequired,
  touched: _propTypes.default.object,
  errors: _propTypes.default.object,
  hideErrors: _propTypes.default.bool,
  setTouched: _propTypes.default.func.isRequired,
  setFieldValue: _propTypes.default.func.isRequired,
  customOnChange: _propTypes.default.func,
  isDisabled: _propTypes.default.bool,
  selectedValueField: _propTypes.default.string
};
var _default = FormikSingleSelectField;
exports.default = _default;

//# sourceMappingURL=FormikSingleSelectField.js.map